module.exports = __webpack_public_path__ + "static/media/yelpcamp2.9e4a6db9.jpg";